import styled from 'styled-components';


const Container = styled.div`
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;

  @media (min-width: 768px) {
    width: 750px;
  }

  @media (min-width: 990px) {
    width: 930px;
  }

  @media (min-width: 1200px) {
    width: 1140px;
  }

  @media (min-width: 1440px) {
    width: 1380px;
  }
`;


const ContainerChildrenWrapper = styled.div`
  display: flex;
`;
ContainerChildrenWrapper.displayName = 'ContainerChildrenWrapper';

export {
  ContainerChildrenWrapper,
};
export default Container;
